import { Button } from '@/atoms/Button'
import { AuthErrorBanner } from '@/molecules/AuthErrorBanner'
import { FormField } from '@/molecules/FormField'
import { useLoginForm } from '@/hooks/useLoginForm'

export function LoginForm() {
  const {
    email,
    password,
    loginError,
    isSubmitting,
    onEmailChange,
    onPasswordChange,
    onSubmit,
  } = useLoginForm()

  return (
    <form className="flex flex-col gap-5" onSubmit={onSubmit} noValidate>
      <div className="flex flex-col gap-1">
        <p className="font-mono text-[0.7rem] uppercase tracking-[0.18em] text-muted">
          Superadmin
        </p>
        <h1 className="font-display text-3xl font-medium tracking-[-0.02em] text-ink">
          Sign in
        </h1>
        <p className="text-sm text-muted">
          Manage agency accounts on the internal platform.
        </p>
      </div>

      <AuthErrorBanner message={loginError} />

      <FormField
        label="Email"
        name="email"
        type="email"
        value={email}
        autoComplete="email"
        placeholder="you@onnrecord.com"
        disabled={isSubmitting}
        onChange={onEmailChange}
      />

      <FormField
        label="Password"
        name="password"
        type="password"
        value={password}
        autoComplete="current-password"
        placeholder="Enter your password"
        disabled={isSubmitting}
        onChange={onPasswordChange}
      />

      <Button type="submit" disabled={isSubmitting} className="w-full">
        {isSubmitting ? 'Signing in…' : 'Sign in'}
      </Button>
    </form>
  )
}
